export default "__VITE_ASSET__419d6fe6__"